// Reposition the wishlist button on the product page + rerender it on variant change
document.addEventListener('DOMContentLoaded', () => {
  const infoContainer = document.querySelector('.product__info-container');
  if (!infoContainer) return;

  let savedButton = null;

  const moveWishlistButton = () => {
    const buttonInDom = document.querySelector('div[id*="xb_wishlist_button_wishlist_"]');
    if (buttonInDom) savedButton = buttonInDom;

    const target = document.querySelector('div[id*="price-template--"] .price__container');

    if (savedButton && target && savedButton.parentElement !== target) {
      target.appendChild(savedButton);
    }
  };

  moveWishlistButton();

  const observer = new MutationObserver((mutations) => {
    const hasNewNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
    if (hasNewNodes) moveWishlistButton();
  });

  observer.observe(infoContainer, { childList: true, subtree: true });
});